/** Platform-aware shortcut labels and matching. */

// Detect the platform exactly as CodeMirror does, so "Mod" means the same key everywhere.
const platform = typeof navigator === 'undefined' ? '' : navigator.platform;

export const isMac = /Mac|iP(hone|[oa]d)/.test(platform);

const MAC: Record<string, string> = { Mod: '⌘', Shift: '⇧', Alt: '⌥', Ctrl: '⌃' };
const PC: Record<string, string> = { Mod: 'Ctrl', Shift: 'Shift', Alt: 'Alt', Ctrl: 'Ctrl' };

/** "Mod-Shift-s" → "⇧⌘S" on macOS, "Ctrl+Shift+S" elsewhere. */
export function shortcutLabel(spec: string): string {
  const parts = spec.split('-');
  const key = parts.pop()!;
  const keyLabel = key.length === 1 ? key.toUpperCase() : key;
  if (isMac) {
    const order = ['Ctrl', 'Alt', 'Shift', 'Mod'];
    return parts.sort((a, b) => order.indexOf(a) - order.indexOf(b)).map((p) => MAC[p]).join('') + keyLabel;
  }
  return [...parts.map((p) => PC[p]), keyLabel].join('+');
}

/**
 * Browsers keep ⌘N/⌘W (Ctrl+N/W) for their own windows and tabs; a page cannot
 * claim them. MyTXT still binds them — they work in a desktop shell or an
 * installed app — but only advertises them where they actually work.
 */
const standalone =
  typeof window !== 'undefined' &&
  (('__TAURI_INTERNALS__' in window) || (typeof matchMedia === 'function' && matchMedia('(display-mode: standalone)').matches));
const BROWSER_RESERVED = new Set(['Mod-n', 'Mod-Alt-n', 'Mod-w']);

/** The label to show for a shortcut, or undefined when it cannot work here. */
export function shortcutHint(spec: string): string | undefined {
  return !standalone && BROWSER_RESERVED.has(spec) ? undefined : shortcutLabel(spec);
}

export function isMod(event: KeyboardEvent | React.KeyboardEvent): boolean {
  return isMac ? event.metaKey : event.ctrlKey;
}
